import { styleConstants } from '@paywithextend/components'
import React from 'react'
import { css } from 'styled-components'

interface ConnectionOptionsContainerProps {
  className?: string
  showErrors?: boolean
}

const ConnectionOptionsContainer: React.FC<
  React.PropsWithChildren<ConnectionOptionsContainerProps>
> = (props): React.ReactElement => {
  return (
    <div
      className={props.className}
      css={css`
        display: flex;
        flex-direction: column;
        border-radius: 10px;
        border: 1px solid ${styleConstants.colors.gray_medium};
        width: 100%;
        overflow: hidden;

        ${!!props.showErrors &&
        css`
          border: 1px solid ${styleConstants.colors.red};
        `}
      `}
    >
      {props.children}
    </div>
  )
}

export default ConnectionOptionsContainer
